/**
 * @author liqiuqi
 * @date 2022 2022/5/17 18:43
 */
export const FILTER_TABS = [
  { id: 0, name: "综合", val: "-1", label: "综合" },
  { id: 1, name: "招标信息", val: "-1", label: "招标" },
  { id: 2, name: "中标信息", val: "-1", label: "中标" },
  { id: 3, name: "拟在建项目", val: "101", label: "拟建" },
  { id: 4, name: "审批项目", val: "301", label: "审批" },
];

//跳转导出
export const SEARCH_EXPORT_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/myFocus_getExport.html";

//立即查看监控记录
export const VIEW_MONITOR_RECORD_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/userApplication_Monitor.html";

//修改监控企业名称
export const MODIFY_MONITOR_COMPANYNAME_URL = "/enterprise-monitoring";

//查看订单
export const VIEW_ORDER_URL = process.env.VUE_APP_OLD_USER_CENTER_URL + "/tradeCenter_Order.html";

//查看公司招投标信息
export const VIEW_BIDDING_INFO_URL = process.env.VUE_APP_OLD_SEARCH_URL + "/index.html";
